<template>
  <v-app-bar
    clipped-left
    app
    dark
    height='60'
    fixed
  >
    <v-app-bar-nav-icon @click="toggleSidebar" v-if="loggedIn" id="hamburger-btn">
      <v-icon>menu</v-icon>
    </v-app-bar-nav-icon>
    <v-toolbar-title>
      <v-container>
        <v-img
          class="logo mr-2"
          src="../../assets/logo.png"
          contain
          height="40"
          width="40"
          alt="Buzz Solutions"
          @click="$router.push({ name: 'Landing' }).catch((e) => e)"
          style="cursor:pointer"
        ></v-img>
      </v-container>
    </v-toolbar-title>
    <v-toolbar-items v-if="!isMobile">
      <!-- <v-select
        v-if="loggedIn && showProjectsOnThisRoute"
        :items="projects"
        item-value="pid"
        item-text="name"
        :value="currentProject"
        id="projects-select"
        class="mt-3"
        @change="enterProject"
        solo
        dense
        :loading="loadingProjects"
      ></v-select> -->
      <RedirectByProject />
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-dialog
      v-if="loggedIn"
      v-model="dialog"
      width="650"
    >

      <template v-slot:activator="{ on: dialog, attrs }">
        <v-tooltip bottom >
          <template v-slot:activator="{ on: tooltip }">
            <v-icon v-on="{ ...dialog, ...tooltip }" v-bind="attrs">
              help
            </v-icon>
          </template>
          Click to watch tutorial video
        </v-tooltip>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Power-AI Tutorial</v-card-title>

        <v-card-text style="margin-top: 10px">
          <video v-if="dialog" width="600" controls src="https://storage.googleapis.com/buzz-powerai-static--asset-access/PowerAI%20Platform%20Video.mp4" autoplay />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="shouldShowTrigger"
      v-model="triggerDialog"
      width="650"
    >
      <template v-slot:activator="{ on: triggerDialog, attrs }">
        <v-toolbar-items>
          <v-tab>
               <span v-on="{ ...triggerDialog }" v-bind="attrs">
              Trigger Ingestion
            </span>
          </v-tab>

        </v-toolbar-items>
      </template>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2" >
        Trigger Ingestion Workflow
      </v-card-title>
      <loading-overlay type="Ingestion Trigger"  :loading="isLoading"/>
      <v-menu
        v-model="triggerDatePicker"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="5">
              <v-text-field
                v-model="startDate"
                label="Date"
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                :disabled="missionId !== ''"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="text-center d-flex align-center justify-center">
              <span class="grey--text font-weight-bold">OR</span>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model="missionId"
                label="Mission ID"
                prepend-icon="mdi-pound"
                @input="missionNumberChangeHandler"
                :disabled="startDate !== ''"
              />
            </v-col>
          </v-row>
        </template>
        <v-date-picker v-model="startDate" no-title @input="datePicked"></v-date-picker>
      </v-menu>

      <v-divider></v-divider>

      <v-card-actions style="display: flex;justify-content: flex-end">

        <v-btn color="primary" text @click="triggerDialog = false">
          close
        </v-btn>
        <v-btn color="primary" text @click="triggerIngestion">
          Trigger
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
    <v-toolbar-items>
      <v-tab
        v-for="tab in tabList"
        :key="tab.title"
        ripple
        :to="tab.path"
        class="navbar-tab"
        :id="tab.id"
        @click="onClickTab(tab.title)"
      >
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-toolbar-items>
    <v-snackbar v-model="snackbar" :timeout="3000">
      Media ingestion triggered successfully
    </v-snackbar>
    <v-snackbar v-model="errorSnackbar" :timeout="3000">
      Media ingestion triggered failed. Contact support.
    </v-snackbar>

  </v-app-bar>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import links from '@components/layouts/links';
import RedirectByProject from '@components/layouts/RedirectByProject.vue';
import missions from '@services/missions';
import LoadingOverlay from '@components/common/loaders/LoadingOverlay.vue';

export default {
  name: 'Navbar',
  props: ['isMobile', 'drawerStatus'],
  components: {
    LoadingOverlay,
    RedirectByProject,
  },
  data: () => ({
    projects: [],
    isLoading: false,
    snackbar: false,
    errorSnackbar: false,
    dialog: false,
    triggerDatePicker: false,
    startDate: '',
    missionId: '',
    window: {
      width: 0,
      height: 0,
    },
    triggerDialog: false,
    miniSidebar: false,
    drawer: true,
    showProjectsOnThisRoute: true,
  }),
  methods: {
    ...mapActions(['logout', 'getProjects']),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    toggleSidebar() {
      this.drawer = !this.drawer;
      this.$emit('toggleSidebar', this.drawer);
    },
    async triggerIngestion() {
      this.isLoading = true;
      try {
        await missions.ingestMedia(
          {
            queue_start_date: this.startDate === '' ? null : this.startDate,
            external_mission_id: this.missionId === '' ? null : this.missionId,
          },
        );
        this.startDate = '';
        this.missionId = '';
        this.snackbar = true;
        this.triggerDialog = false;
        this.isLoading = false;
      } catch (error) {
        this.startDate = '';
        this.missionId = '';
        this.errorSnackbar = true;
        this.triggerDialog = false;
        this.isLoading = false;
      }
    },
    datePicked(date) {
      this.triggerDatePicker = false;
      this.startDate = date;
    },
    missionNumberChangeHandler(mission) {
      this.missionId = mission;
    },
    adjustSidebar() {
      this.miniSidebar = !this.miniSidebar;
      this.$emit('toggleSidebar', !this.miniSidebar);
    },
    enterProject(pid) {
      this.$router.push({ name: 'Redirect', params: { pid, name: this.$route.name } });
    },
    async onClickTab(tabTitle) {
      if (tabTitle === 'Logout') {
        await this.logout();
        this.$router.push({ name: 'Login' });
      }
    },
    showProjects() {
      const blackList = ['InsightsContent'];
      this.showProjectsOnThisRoute = !blackList.includes(this.$route.name);
    },
  },
  computed: {
    ...mapGetters(['loggedIn', 'companyHas', 'currentCompany', 'currentUser', 'allProjects', 'currentProject', 'loadingProjects', 'allTeams', 'firstFactorAuthenticated', 'secondFactorAuthenticated']),
    tabList() {
      let tabs;
      if (this.authenticationLevel === 'Authenticated') {
        tabs = [...links.auth];
        const settingsTabIndex = tabs.findIndex((tab) => tab.title === 'Settings');
        tabs[settingsTabIndex].path = `/settings/user/${this.currentUser.uid}/profile`;
      } else if (this.authenticationLevel === 'First Factor Authenticated') {
        const [logoutTab] = links.auth.filter((link) => link.title === 'Logout');
        tabs = [logoutTab];
      } else {
        tabs = links.guest;
      }

      if (this.isMobile) return [];
      return tabs;
    },
    shouldShowTrigger() {
      const hasMediaHub = this.companyHas('asset_metadata')
        && this.companyHas('mission_metadata')
        && this.$route.path === '/projects/view/grid';
      return hasMediaHub && this.loggedIn;
    },
    activeProject() {
      return this.$route.name === 'Project' ? this.currentProject : null;
    },
    authenticationLevel() {
      if (this.loggedIn) return 'Authenticated';
      if (this.firstFactorAuthenticated && !this.secondFactorAuthenticated) return 'First Factor Authenticated';
      return 'Not Authenticated';
    },
    // showClientLogo() {
    //   return window.location.hostname === 'newfoundland.buzzpowerai.com';
    // },
  },
  watch: {
    drawerStatus(newStatus) {
      this.drawer = newStatus;
    },
    $route() {
      this.showProjects();
    },
  },
  async created() {
    this.showProjects();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    let res;

    if (this.loggedIn && this.allProjects.length === 0) {
      if (this.currentUser.adminStatus) {
        res = await this.getProjects(`company_id=${this.currentUser.cid}`);
      } else {
        // Get User Projects
        res = await this.getProjects(`company_id=${this.currentUser.cid}&user_id=${this.currentUser.uid}`);
      }
      this.projects = res.data;
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
